import request from '@Sys~/api/request'
import { apiUrl, type } from './env'
import store from '@Sys~/store'

const gateUrl = apiUrl.gateUrl

function ajax_fn(url, data, method, header) {
  header.header_username = encodeURI(store.getters.realName); // realName
  return request({
    headers: header,
    baseURL: gateUrl,
    url: url,
    method: method,
    params: method == 'GET'? data : '',
    data: method != 'GET' ? data : '',
    withCredentials: false
  })
}

//数据源管理模块
//获取标签列表
export function queryBy_searchForm(data) {
  return ajax_fn("/label/", data, "GET", {})
}
//新增
export function create_datasForm(data) {
  return ajax_fn("/label/addLabel", data, "post", {})
}
//修改
export function update_datasForm(data) {
  return ajax_fn("/label/updateLabel", data, "post", {})
}
//删除
export function delete_datasForm(data) {
  return ajax_fn("/label/"+data,{} , "delete", {})
}

